import { render, staticRenderFns } from "./ThematicArea.vue?vue&type=template&id=52d08dc7&scoped=true"
import script from "./ThematicArea.vue?vue&type=script&lang=js"
export * from "./ThematicArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d08dc7",
  null
  
)

export default component.exports